<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="850">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-PATIENT-IMPORT-BATCH' : 'EDIT-PATIENT-IMPORT-BATCH') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <!--Name-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'PATIENT-IMPORT-NAME-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label for="organizationDropdown" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'PROGRAM-EDIT-ORGANIZATION' | translate}} *
                    </span>
                    <kendo-combobox id="organizationDropdown" [data]="organizationsFiltered" [valueField]="'id'"
                        [textField]="'name'" formControlName="organization" [filterable]="true"
                        [itemDisabled]="organizationItemDisabled" (filterChange)="filterOrganizations($event)">
                    </kendo-combobox>
                </label>
            </div>
        </div>
        <div class="row">
            <!--Description-->
            <div class="col-12">
                <label for="description" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DESCRIPTION' | translate }}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100" formControlName="description"
                        maxlength="1024">
                    </textarea>
                </label>
            </div>
        </div>
        <!--CSV File-->
        <div class="row">
            <div [ngClass]="{'col-6': isLocked, 'col-3': !isLocked, 'pr-0': !isLocked}">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'FILENAME' | translate}} *
                    </span>
                    <input id="importFilename" kendoTextBox formControlName="importFilename" [readonly]="true" />
                    <input type="file" id="csvFile" #csvFileInput accept=".csv, text/plain" class="d-none"
                        (change)="handleCsvInput($event.target.files)" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="importFilename.hasError('required') && importFilename.touched">
                        {{'IMPORT-CSV-FILE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-3" *ngIf="!isLocked">
                <button appPreventClick kendoButton type="button" (click)="csvFileInput.click()" class="float-right"
                    style="margin-top:34px">
                    {{'IMPORT-SELECT-FILE' | translate}}<i class="far fa-upload fa-white"></i>
                </button>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'BATCH-SUBJECT-IDENTIFIERS' | translate}}
                    </span>
                    <kendo-multiselect [data]="systemSubjectIdentifiers" [valuePrimitive]="true"
                        formControlName="subjectIdentifiers" [textField]="'displayName'" [valueField]="'id'">
                    </kendo-multiselect>
                </label>
            </div>
        </div>
        <!--Channels-->
        <div class="row">
            <!--Enrollment Channel-->
            <div class="col-6">
                <label for="channel" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'CHANNEL-ENROLLMENT' | translate }}
                    </span>
                    <kendo-combobox id="channel" class="w-100" formControlName="channel" [valuePrimitive]="false"
                        [itemDisabled]="itemDisabled" [data]="groupedChannels" [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                </label>
            </div>
            <!--Referral Channel-->
            <div class="col-6">
                <label for="channel" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'REFERRAL-CHANNEL' | translate }}
                    </span>
                    <kendo-combobox id="referralChannel" class="w-100" formControlName="referralChannel"
                        [valuePrimitive]="false" [itemDisabled]="itemDisabled" [data]="groupedChannelsReferrals"
                        [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'CARE-TEAM-CREATION-LEVEL' | translate}} *
                    </span>
                </label>
                <div class="row" style="margin-top:-20px;">
                    <div class="col-6 pl-5">
                        <!--PCP Creation Level-->
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'CARE-TEAM-CREATION-PCP' | translate}}
                            </span>
                            <div>
                                <span>
                                    <input type="radio" value="PATIENT" name="pcpCreationLevel"
                                        formControlName="pcpCreationLevel" id="radioPatientCareTeamLevelPcp"
                                        kendoRadioButton />
                                    <label class="k-radio-label" for="radioPatientCareTeamLevelPcp"
                                        [ngClass]="{'k-disabled': pcpCreationLevel.disabled}">{{'CARE-TEAM-CREATION-LEVEL-PATIENT'
                                        | translate:patientLabel}}
                                    </label>
                                    <input type="radio" value="CASE" name="pcpCreationLevel"
                                        formControlName="pcpCreationLevel" id="radioCaseCareTeamLevelPcp"
                                        kendoRadioButton />
                                    <label class="k-radio-label" for="radioCaseCareTeamLevelPcp"
                                        [ngClass]="{'k-disabled': pcpCreationLevel.disabled}">{{'CARE-TEAM-CREATION-LEVEL-CASE'
                                        | translate }}
                                    </label>
                                </span>
                            </div>
                        </label>
                    </div>
                    <div class="col-6">
                        <!--Contact Creation Level-->
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'CARE-TEAM-CREATION-CONTACT' | translate}}
                            </span>
                            <div>
                                <span>
                                    <input type="radio" value="PATIENT" name="contactCreationLevel"
                                        formControlName="contactCreationLevel" id="radioPatientCareTeamLevelContact"
                                        kendoRadioButton />
                                    <label class="k-radio-label" for="radioPatientCareTeamLevelContact"
                                        [ngClass]="{'k-disabled': contactCreationLevel.disabled}">{{'CARE-TEAM-CREATION-LEVEL-PATIENT'
                                        | translate:patientLabel}}
                                    </label>
                                    <input type="radio" value="CASE" name="contactCreationLevel"
                                        formControlName="contactCreationLevel" id="radioCaseCareTeamLevelContact"
                                        kendoRadioButton />
                                    <label class="k-radio-label" for="radioCaseCareTeamLevelContact"
                                        [ngClass]="{'k-disabled': contactCreationLevel.disabled}">{{'CARE-TEAM-CREATION-LEVEL-CASE'
                                        | translate }}
                                    </label>
                                </span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <input id="automaticDiscardOnError" type="checkbox" formControlName="automaticDiscardOnError"
                    kendoCheckBox />
                <label class="k-checkbox-label k-text-uppercase dark" for="automaticDiscardOnError"
                    [ngClass]="{'k-disabled': automaticDiscardOnError.disabled}">{{ 'AUTOMATIC-DISCARD-ON-ERROR' |
                    translate}}
                </label>
            </div>
            <div class="col-6">
                <input id="automaticImport" type="checkbox" formControlName="automaticImport" kendoCheckBox />
                <label class="k-checkbox-label k-text-uppercase dark" for="automaticImport"
                    [ngClass]="{'k-disabled': automaticImport.disabled}">{{ 'AUTOMATIC-IMPORT' |
                    translate}}</label>
            </div>
        </div>
        <div class="mt-2" *ngIf="communityEnabled">
            <div>
                <input id="sendInvite" type="checkbox" formControlName="sendInvite" kendoCheckBox />
                <label class="k-checkbox-label k-text-uppercase dark" for="sendInvite"
                    [ngClass]="{'k-disabled': sendInvite.disabled}">{{
                    'SEND-INVITE' | translate}}
                </label>
            </div>
            <!--Send Invite properties-->
            <div *ngIf="sendInvite !== undefined && sendInvite.value">
                <kendo-card class="w-100 mt-2">
                    <kendo-card-body class="pt-1 pb-3">
                        <!--Email Template-->
                        <div class="row">
                            <div class="col-12">
                                <label for="inviteTemplate" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'EMAIL-TEMPLATE' | translate }} *
                                    </span>
                                    <kendo-multicolumncombobox formControlName="inviteTemplate"
                                        [data]="sendInviteTemplates" [textField]="'name'" [valueField]="'id'"
                                        [valuePrimitive]="false">
                                        <kendo-combobox-column [field]="'name'" title="{{'NAME' | translate}}"
                                            [width]="150">
                                        </kendo-combobox-column>
                                        <kendo-combobox-column [field]="'mimeType'"
                                            title="{{'EMAIL-TEMPLATE-MIME-TYPE' | translate}}" [width]="80">
                                        </kendo-combobox-column>
                                        <kendo-combobox-column [field]="'language'"
                                            title="{{'EMAIL-TEMPLATE-LANGUAGE' | translate}}" [width]="50">
                                        </kendo-combobox-column>
                                    </kendo-multicolumncombobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="inviteTemplate.hasError('required') && inviteTemplate.touched">
                                        {{'REQUIRED-EMAIL-TEMPLATE' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'DATE-TO-SEND' | translate}} *
                                    </span>
                                    <kendo-datetimepicker class="w-100" formControlName="inviteSendOn">
                                    </kendo-datetimepicker>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="inviteSendOn.hasError('required') && inviteSendOn.touched">
                                        {{'REQUIRED-DATE-TO-SEND' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'NUMBER-VALID-DAYS' | translate}} *
                                    </span>
                                    <kendo-numerictextbox [format]="'n0'" formControlName="inviteValidDays"
                                        class="w-100">
                                    </kendo-numerictextbox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="inviteValidDays.hasError('required') && inviteValidDays.touched">
                                        {{'REQUIRED-NUMBER-VALID-DAYS' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </kendo-card-body>
                </kendo-card>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ (isLocked ? 'CLOSE' : 'CANCEL') | translate }}</button>
        <button *ngIf="!isLocked" appPreventClick class="k-button k-primary"
            [disabled]="!editForm.valid || !editForm.dirty" (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>